<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">

                        <div class="card-body table-responsive">
                            <div class="row mb-2 align-items-end">
                                <div class="col-xl-2 col-md-3 col-sm-6 col-12 mb-2">
                                    <label>{{$t("report.date.startDate")}}</label>
                                    <datepicker
                                            class="form-control"
                                            format="dd/MM/yyyy"
                                            v-model="filter.startDate"
                                            :clear-button="true"
                                            @input="changeStartDate"
                                    ></datepicker>
                                </div>
                                <div class="col-xl-2 col-md-3 col-sm-6 col-12 mb-2">
                                    <label>{{$t("report.date.endDate")}}</label>
                                    <datepicker
                                            class="form-control"
                                            format="dd/MM/yyyy"
                                            v-model="filter.endDate"
                                            :clear-button="true"
                                    ></datepicker>
                                </div>
                                <div v-if="isAuthorized" class="col-xl-3 col-lg-4 col-md-6 col-sm-8 col-12 mb-2">
                                    <label>{{$t("realEstate.field.evaluator")}}</label>
                                    <v-select v-model="filter.employee" label="name"
                                              :options="employees"
                                              :filterable="false"
                                              @search:focus="onEmployeFocus">
                                        <template slot="option" slot-scope="option" v-if="option && option.name">
                                            <div v-html="option.name"></div>
                                        </template>
                                        <template slot="selected-option"
                                                  v-if="filter && filter.employee && filter.employee.name">
                                            <div v-html="filter.employee.name"></div>
                                        </template>
                                        <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                    </v-select>
                                </div>

                                <div class="col-xl-3 col-md-2 col-sm-4 col-6 mb-2">
                                    <label for="search">{{$t('finance.field.search')}}</label>
                                    <div class="input-group">
                                        <div class="input-group-append">
                                            <button class="all-btn m-0" @click="initList">
                                                <i class="fa fa-search"></i>
                                                <span>{{$t('finance.field.search')}}</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="hasPermission('CASH_TRANSFER') && isAppraiser" class="col-md-2 col-sm-6 col-6">
                                    <button type="button" class="all-btn delete-btn ml-auto ml-sm-0 ml-xl-auto mb-2" @click="addAppraiserUrl()">
                                        {{$t("finance.deposit.cashTransfer")}}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="table-wrapper">
                              <table class="customers">
                                <thead class="table-head">
                                <tr>
                                    <th rowspan="3" width="35%">Ф.И.О</th>
                                    <th rowspan="3" width="5%">Объект номи</th>
                                    <th colspan="4">Кирим</th>
                                    <th colspan="4">Чиким</th>
                                </tr>
                                <tr>
                                    <th colspan="2">Бажарилган иш</th>
                                    <th colspan="2">Депозит тўлдириш</th>
                                    <th colspan="2">Бажарилган иш</th>
                                    <th colspan="2">Депозитдан чиким</th>
                                </tr>
                                <tr>
                                    <th>Сана</th>
                                    <th>Сумма</th>
                                    <th>Сана</th>
                                    <th>Сумма</th>
                                    <th>Сана</th>
                                    <th>Сумма</th>
                                    <th>Сана</th>
                                    <th>Сумма</th>
                                </tr>
                                </thead>
                                <tbody v-if="!loading && results && results.data">
                                <tr v-for="(result) in results.data" :key="result.index">
                                    <td :title="result.evaluationObjectFullInfo" class="font-weight-bold">
                                        <span class="font-weight-bold">#{{result.objectId}}</span>
                                        <span class="">
                                            {{result.objectName}}
                                        </span><br/>
                                        <span class="font-weight-bold small">
                                            <b>{{result.createUserName}}</b>
                                        </span>
                                    </td>
                                    <td class="text-center">
                                        <span>
                                        {{result.evlObjectType}}
                                        </span>
                                    </td>
                                    <td class="text-center">
                                        <span v-if="result.confirmedDate">
                                        {{result.confirmedDate}}
                                        </span>
                                    </td>
                                    <td class="text-center">
                                        <span :style="statusColor(result.agentDepositId)"
                                              v-if="result.agentSalary">
                                            {{result.agentSalary | currency('', 2, { thousandsSeparator: ' ' })}}
                                        </span>
                                    </td>
                                    <td><span v-if="result.payDate">
                                        {{result.payDate}}
                                        </span></td>
                                    <td class="text-right">
                                        <span v-if="result.payAmount"> {{result.payAmount | currency('', 2, { thousandsSeparator: ' ' })}}</span>
                                    </td>
                                    <td>{{result.paymentDate}}</td>
                                    <td>
                                        <span v-if="result.agentTransactionAmount">
                                            {{result.agentTransactionAmount | currency('', 2, { thousandsSeparator: ' '})}}
                                        </span>
                                    </td>
                                    <td>{{result.creditAccount}}</td>
                                    <td>{{result.creditAccount}}</td>
                                </tr>
                                </tbody>
                                <tfoot>
                                <tr>
                                    <td class="font-weight-bold"><span></span></td>
                                    <td class="text-right font-weight-bold"></td>
                                    <td class="text-right font-weight-bold"></td>
                                    <td class="text-right font-weight-bold">{{ totalAgentSalary.balance |
                                        currency('', 2, { thousandsSeparator: ' ' }) }}
                                    </td>
                                    <td class="text-right font-weight-bold"></td>
                                    <td class="text-right font-weight-bold">{{ totalAgentSalary.deposit |
                                        currency('', 2, { thousandsSeparator: ' ' }) }}
                                    </td>
                                    <td class="text-right font-weight-bold"></td>
                                    <td class="text-right font-weight-bold">{{ totalAgentSalary.paymentAmount |
                                        currency('', 2, { thousandsSeparator: ' ' }) }}
                                    </td>
                                    <td colspan="0" class="font-weight-bold"></td>
                                    <td colspan="0" class="font-weight-bold"></td>
                                </tr>
                                <tr>
                                    <td class="font-weight-bold">Баланс:</td>
                                    <td colspan="9" class="font-weight-bold text-center"><span style="font-size: 20px;">{{totalAgentSalary.balance + totalAgentSalary.deposit | currency('', 2, { thousandsSeparator: ' ' }) }}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="font-weight-bold">Фойдаланувчи баланси қолдиғи:</td>
                                    <td colspan="9" class="font-weight-bold text-center"><span style="font-size: 20px;">{{totalAgentSalary.totalUserBalance | currency('', 2, { thousandsSeparator: ' ' }) }}</span></td>
                                </tr>

                                </tfoot>
                            </table>
                            </div>
                        </div>
                        <div class="text-center">
                            <div class="loader mt-5 mb-5" v-if="loading"></div>
                            <span class="no-data mt-5 mb-5"
                                  v-if="!loading && results && results.data && results.data.length===0">{{$t("messages.list.empty")}}</span>
                        </div>
                        <div class="row" v-if="!loading && results && results.total && results.total > 1">
                            <div class="col-12 pt-3 pb-3">
                                <b-pagination :total-rows="results.total" v-model="filter.page.page"
                                              :per-page="filter.page.size" @change="onPageChange">
                                </b-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import initFilterModel from '@/shared/filter'
    import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
    import Datepicker from 'vuejs-datepicker';
    // import AgentSelect from '@/components/AgentSelect';
    // import CustomDatePicker from '@/views/common/CustomDatePicker'

    import {formatDate/*, parseDate, formatDateText, findBy*/} from '@/shared/utils';

    export default {
        name: "DepositAppraiserList",
        components: {
            'b-pagination': bPagination,
            Datepicker,
            // AgentSelect,
            // CustomDatePicker
        },
        data() {
            return {
                loading: false,
                filter: initFilterModel(),
                results: null,
                data: null,
                newfromBalanceDate: null,
                fromBalanceDate: new Date("01/06/2022"),
                employees: [],
                admins: [],
                isAuthorized: false,
                isAppraiser: false,
                depositsDto: {
                    id: null,
                    userCardsType: null
                }
            }
        },
        methods: {
            initList() {
                this.loading = true;
                this.isAuthoritie();
                this.isAppraisers();
                this.$http.post('/report/list/user/deposit', this.filter)
                    .then(res => {
                        this.results = res;
                        this.newfromBalanceDate = this.filter.startDate;
                        this.loading = false
                    }, err => {
                        console.log(err);
                        this.loading = false
                    });
            },
            isAuthoritie() {
                const authorities = this.$store.state.profile.authorities;
                for (const role of authorities) {
                    if (role == "ROLE_GENERAL_DIRECTOR" || role == "ROLE_DIRECTOR") {
                        this.isAuthorized=true;
                    }
                }
            },
            isAppraisers() {
                const authorities = this.$store.state.profile.authorities;
                for (const role of authorities) {
                    if (role === "ROLE_APPRAISER") {
                        this.isAppraiser=true;
                    }
                }
            },
            onPageChange(page) {
                this.filter.page.page = page;
                this.initList();
            },
            changeStartDate() {
                if (this.filter.startDate < this.fromBalanceDate) {
                    this.filter.startDate = this.fromBalanceDate;
                    this.newfromBalanceDate = this.filter.startDate;
                    this.$swal({
                        title: this.$t('messages.common.warning'),
                        text: formatDate(this.fromBalanceDate) + ' дан олдинги сана танлаш мумкин эмас',
                        type: 'warning'
                    });
                }
            },
            onEmployeFocus() {
                this.employees = [];
                this.filter.search = '';
                this.$http.post('employes/search', this.filter)
                    .then(res => {
                        this.employees = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            getAdminFocus() {
                this.filter.search = 'ROLE_ADMIN';
                this.$http.post('/user/list-role', this.filter)
                    .then(res => {
                        this.admins = res.data.data;
                        this.filter.search = '';
                    }, err => {
                        console.log(err)
                    });
            },
            addAppraiserUrl() {
                const totalCash = (this.totalAgentSalary.totalUserBalance);
                if (totalCash <= 0) {
                    this.$swal({
                        title: this.$t('common.error'),
                        text: " Summa 0 dan ko'p bo'lishi kerak ",
                        type: 'error'
                    });
                    return;
                }
                this.depositsDto.user = this.$store.state.profile;
                this.depositsDto.cash = totalCash;
                this.depositsDto.userCardsType = 'DEPOSIT';
                this.loading = true;
                this.$http.post('/deposits/user/save', this.depositsDto)
                    .then(res => {
                        const response = res.data;
                        if (response.status === 'SUCCESS') {
                            this.$router.push("users-balance-list");
                        } else {
                            this.$swal({
                                title: this.$t('common.warning'),
                                text: response.message,
                                type: 'warning'
                            });
                        }
                        this.loading = false;
                    }, err => {
                        this.loading = false;
                        console.log(err);
                    });
            },
            statusColor(rights) {
                if (rights == null) {
                    return 'color:blue;font-weight:bold';
                } else {
                    return 'color:red;font-weight:bold';
                }
            }
        },
        created() {
            this.filter.startDate = new Date(this.fromBalanceDate.getFullYear(), this.fromBalanceDate.getMonth(), 1);
            this.filter.endDate = new Date();


            this.initList()
        },
        computed: {
            totalAgentSalary() {
                let result = 0;
                let deposit = 0;
                let paymentAmount = 0;
                let totalUserBalance = 0;
                if (this.results != null) {
                    Object.keys(this.results.data).forEach(key => {
                        let val = this.results.data[key];
                        result = result + parseFloat(val.agentSalary);

                        deposit = deposit + parseFloat(val.payAmount);
                        paymentAmount = paymentAmount + parseFloat(val.agentTransactionAmount);
                        if (val.agentDepositId === undefined) {
                            totalUserBalance = totalUserBalance + parseFloat(val.agentSalary);
                        }
                    });
                }
                return {"balance": result, "paymentAmount": paymentAmount, "deposit": deposit, "totalUserBalance": totalUserBalance};

            }
        }
    }
</script>

<style scoped>

</style>